import React from "react";
import { CheckCircle2, LockKeyhole, PhoneCall } from "lucide-react";

interface PartnerAuthShellProps {
  children: React.ReactNode;
}

const PartnerAuthShell: React.FC<PartnerAuthShellProps> = ({ children }) => (
  <main className="min-h-[100dvh] bg-slate-50 lg:grid lg:grid-cols-[minmax(420px,0.9fr)_minmax(520px,1.1fr)]">
    <section className="hidden bg-slate-950 px-10 py-12 text-white lg:flex lg:flex-col lg:justify-between xl:px-16">
      <div className="flex items-center gap-3">
        <div className="flex h-12 w-12 items-center justify-center overflow-hidden rounded-xl bg-white p-1.5"><img src="/logo.svg" alt="Διαθερμική" className="h-full w-full object-contain" /></div>
        <div><p className="text-lg font-bold">Diathermiki</p><p className="text-xs text-slate-400">Portal συνεργατών</p></div>
      </div>
      <div className="max-w-lg">
        <p className="text-xs font-bold uppercase tracking-[0.14em] text-sky-400">Η καθημερινή σας οργάνωση</p>
        <h1 className="mt-4 text-4xl font-bold leading-tight tracking-tight xl:text-5xl">Τα νέα leads, οι επόμενες κινήσεις και η απόδοσή σας.</h1>
        <p className="mt-5 text-base leading-7 text-slate-300">Ένα απλό σημείο για να καλέσετε τον πελάτη, να ενημερώσετε το στάδιο και να μη χαθεί καμία ευκαιρία.</p>
        <div className="mt-8 space-y-4">
          {["Άμεση πρόσβαση στα στοιχεία κάθε ανάθεσης", "Γρήγορη κλήση, WhatsApp, SMS και email", "Καθαρή εικόνα pipeline και χρεώσεων"].map((item) => <p key={item} className="flex items-center gap-3 text-sm text-slate-200"><CheckCircle2 className="h-5 w-5 shrink-0 text-emerald-400" />{item}</p>)}
        </div>
      </div>
      <div className="flex items-center gap-6 text-xs text-slate-500"><span className="flex items-center gap-2"><LockKeyhole className="h-4 w-4" /> Ασφαλής πρόσβαση</span><span className="flex items-center gap-2"><PhoneCall className="h-4 w-4" /> Υποστήριξη Διαθερμικής</span></div>
    </section>
    <section className="flex min-h-[100dvh] items-center justify-center px-4 py-8 sm:px-6 lg:min-h-0 lg:px-10">
      <div className="w-full max-w-md">
        <div className="mb-7 flex items-center justify-center gap-3 lg:hidden">
          <div className="flex h-12 w-12 items-center justify-center overflow-hidden rounded-xl border border-slate-200 bg-white p-1.5"><img src="/logo.svg" alt="Διαθερμική" className="h-full w-full object-contain" /></div>
          <div><p className="font-bold text-slate-950">Diathermiki</p><p className="text-xs text-slate-500">Portal συνεργατών</p></div>
        </div>
        {children}
      </div>
    </section>
  </main>
);

export default PartnerAuthShell;
